import makeStyles from '@mui/styles/makeStyles'

import { SEVERITY } from '../../../../../slices/chatBoxSlice'

export const getButtonColor = severity => {
  switch (severity) {
    case SEVERITY.NORMAL:
      return '#BF8A00'
    default:
      return 'black'
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    borderRadius: '8px',
    width: '100%',
    minHeight: '52px',
    padding: 6,
    cursor: 'default',

    '&:last-child': {
      marginBottom: '0'
    }
  },

  root_sevNormal: {
    boxShadow: '0px 20px 30px rgba(191, 138, 0, 0.16)',
    background: '#FFF0C9'
  },

  messages: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column'
  },

  message: {
    marginTop: '6px',
    fontSize: theme.size.base,
    textAlign: 'center',

    '&:first-child': {
      marginTop: '0'
    },

    '& .bold': {}
  },

  message_sevNormal: {
    color: '#BF8A00'
  },

  button: {
    cursor: 'pointer'
  }
}))

export default useStyles
